import React from "react";
import LoginForm from "./LoginForm";
import { IMAGES } from "../../../assets";
import { STRINGS } from "../../../constants";
import { useTranslation } from "react-i18next";

const Login = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full  ">
      <div className="w-[100%]    flex h-[100vh]">
        <div className="w-[50%] relative h-full  bg-[#FE6B010F] lg:block md:hidden sm:hidden hidden  ">
          <div className="flex flex-col items-center justify-between h-full">
            <img
              src={`${process.env.PUBLIC_URL + "/front"}${IMAGES?.logo}`}
              alt="logo"
              className="w-auto h-24 bottom-0 relative mt-12"
            />
            <img
              alt="login_svg"
              src={`${process.env.PUBLIC_URL + "/front"}${
                IMAGES?.reading_ledy
              }`}
              className="w-auto h-96 bottom-0 relative"
            />
          </div>
        </div>
        <div className="w-full   lg:w-[50%]  md:w-full  sm:w-full  px-4   sm:px-28  py-2 flex flex-col justify-center items-center relative">
          <div className=" flex flex-col max-w-[345px]">
            <h2 className="py-1 font-semibold text-3xl">{t(STRINGS.login)}</h2>
            <p className="py-2 text-paragraph pb-3">
              {t(STRINGS.please_enter_your_email_and_password)}
            </p>
            <LoginForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
